export default "__VITE_ASSET__pjIHR0Py__"